export default "assets/images/cnil-rgpd-f7ad223e.png";